import { render, staticRenderFns } from "./OrderRequest.vue?vue&type=template&id=c4aa798e"
import script from "./OrderRequest.vue?vue&type=script&lang=js"
export * from "./OrderRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports